import { render, staticRenderFns } from "./index.vue?vue&type=template&id=22a65f07"
import script from "./createPhysicalVerification.js?vue&type=script&lang=js&external"
export * from "./createPhysicalVerification.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports